<template>
    <Modal draggable v-model="show"
        :width="1200"
        :footer-hide="true"
        title="发货单废单"
        @on-visible-change="onShowChange">
        <Spin v-if="innerSpin"
            size="large"
            fix></Spin>
        <Card :padding="0"
            :bordered="false"
            :dis-hover="true">
            <Row :gutter="16">
                <Col span="24">
                <div class="global-tool-bar">
                    <div class="left-bar">
                        <!-- <span class="title">送货单质检</span> -->
                    </div>
                    <div class="right-bar" style="margin-bottom:20px;" v-if="$checkAccessArray(['B','C','D'])&&preSaleDeliveryRecord.preSaleDeliveryRecordStatus!='关闭'">
						 <!-- <div style="margin-right: 20px;color:red;font-weight:bold;">提示：修改发货日期、发货方式、数量和单价后请点击保存按钮</div>
						 <Poptip v-if="showPoptip"
						    confirm
						    placement="left"
						    title="请确认信息是否无误？"
						    @on-ok="saveDetailInfo"
						    @on-cancel="cancel" style="margin-right: 20px;">
						    <Button type="primary">保存</Button>
						 </Poptip> -->
						 <Poptip v-if="showPoptip"
						        confirm
								placement="left"
						        title="是否已确认所有信息无误？"
						        @on-ok="ok"
						        @on-cancel="cancel" style="margin-right: 20px;">
						        <Button type="error">确认发货</Button>
						    </Poptip>
                        <Button type="success"
                            @click="printDeliveryRecord()">打印发货单</Button>
                    </div>
                </div>
                </Col>
            </Row>

            <Row :gutter="16">
                <Col span="24">
                <Form ref="deliveryForm"
                    label-position="top"
					:rules="ruleValidate"
					>

                    <Row :gutter="16">
						<Col span="4">
						<FormItem label="发货单废单号">
						    <Input :value="preSaleDeliveryRecord.billCode"
						        readonly></Input>
						</FormItem>
						</Col>
                        <Col span="4">
                        <FormItem label="关联定金单号">
                            <Input :value="preSaleDeliveryRecord.preSaleDeliveryRecordRelateOrderRecordCode"
                                readonly></Input>
                        </FormItem>
                        </Col>
                        <Col span="4">
                        <FormItem label="会员号">
                            <Input :value="preSaleDeliveryRecord.userName"
                                readonly></Input>
                        </FormItem>
                        </Col>
                        <Col span="4">
                        <FormItem label="会员电话">
                            <Input :value="preSaleDeliveryRecord.userExternalCustomerContactNumber"
                                readonly></Input>
                        </FormItem>
                        </Col>

                        <Col span="4">
                        <FormItem label="送货总量">
                            <Input :value="preSaleDeliveryRecord.preSaleDeliveryRecordTotalQuantity"
                                readonly></Input>
                        </FormItem>
                        </Col>

                        <Col span="4">
                        <FormItem label="发货日期">
                            <Input v-model="sendDeliveryDate" :value="formatDateString(preSaleDeliveryRecord.preSaleDeliveryRecordDeliveryDate)"
                                ></Input>
                        </FormItem>
                        </Col>
                    </Row>

                    <Row :gutter="16">

                        <Col span="4">
                        <FormItem label="制单时间">
                            <Input :value="formatDateTimeString(preSaleDeliveryRecord.preSaleDeliveryRecordCreateAt)"
                                readonly></Input>
                        </FormItem>
                        </Col>

                        <Col span="4">
                        <FormItem label="制单人">
                            <Input :value="preSaleDeliveryRecord.userExternalCustomerName"
                                readonly></Input>
                        </FormItem>
                        </Col>
						<Col span="4">
							<FormItem label="发货方式">
							   <RadioGroup v-model="preSaleDeliveryRecord.deliveryWays"
							       type="button"
							       size="large"
							       @on-change="onDeliveryWaysChange">
								   <Radio v-for="(item,index) in deliveryWaysList"
								       :key="item.val"
								       :label="item.val">{{ item.label }}
								   </Radio>
							   </RadioGroup>
							</FormItem>
						</Col>
						<Col span="4" v-show="showTransferStation">
							<FormItem label="转运站">
							   <Select v-model="preSaleDeliveryRecord.relateDistributionStationUuid" filterable clearable>
									<Option v-for="(item,index) in stationList" :value="item.distributionStationUuid" :key="item.distributionStationUuid">{{ item.distributionStationName }}</Option>
								</Select>
							</FormItem>
						</Col>
                        <Col span="4" v-show="showTransferStation">
                        	<FormItem label="当前转运站收运费" v-if="$checkAccessArray(['D','S'])">
                        		<Input v-model="preSaleDeliveryRecord.currentDeliveryFee"
                        			></Input>
                        	</FormItem>
                        </Col>
						<Col span="4" v-show="showLogistics">
							<FormItem label="物流单号">
								<Input v-model="preSaleDeliveryRecord.logisticsCode"
									></Input>
							</FormItem>
						</Col>
						<Col span="4"  v-show="showLogistics">
							<FormItem label="物流公司">
								<Input v-model="preSaleDeliveryRecord.preSaleDeliveryRecordLogisticsCompanyName"
									></Input>
							</FormItem>
						</Col>
                    </Row>
					<Row :gutter="16">
						<Col span="4">
						<FormItem label="客户经理">
						    <Input :value="preSaleDeliveryRecord.userCustomerManagerName"
						        readonly></Input>
						</FormItem>
						</Col>
						<Col span="4">
						<FormItem label="佣金比例">
						    <Input :value="preSaleDeliveryRecord.salesAssociateCommissionPercent"
						        readonly></Input>
						</FormItem>
						</Col>
						<Col span="8">
						<FormItem label="客户备注" v-if="$checkAccessArray(['S','B','D'])">
						    <Input :value="preSaleDeliveryRecord.customerMsg"
						        readonly type="textarea"></Input>
						</FormItem>
						</Col>
						<Col span="8">
						<FormItem label="撤销原因" v-if="$checkAccessArray(['S','B','D'])">
						    <Input :value="preSaleDeliveryRecord.cancelReason"
						        readonly type="textarea"></Input>
						</FormItem>
						</Col>
					</Row>
					<Row :gutter="24">
						<Col span="24">
							<!-- <div style="width: 100%;text-align: right;" v-if="$checkAccessArray(['B','C'])&&preSaleDeliveryRecord.preSaleDeliveryRecordStatus!='关闭'">
								<Poptip v-if="showPoptip"
								   confirm
								   placement="left"
								   title="以第一行品种的单价为准,是否将全部品种的单价改成一样？"
								   @on-ok="updatePreSalePlanPrice"
								   @on-cancel="cancel">
								   <Button type="error">批量修改单价</Button>
								</Poptip>
								
							</div> -->
							<FormItem>
								<div slot="label">
									<b>发货单明细</b>
								</div>
								<Table ref="productTable"
									size="small"
									:columns="productTable.columns"
									:data="preSaleDeliveryDetails"
									stripe
									border />
							</FormItem>
						</Col>
					</Row>
                </Form>
                </Col>
            </Row>
        </Card>
    </Modal>
</template>

<script>
import { formatDateString, formatDateTimeString } from '@/libs/logic';
import { DELIVERYWAYS_SELFMENTION, DELIVERYWAYS_TRANSFERSTATION, DELIVERYWAYS_LOGISTICS, deliveryWaysFormat } from '@/libs/baseModelFormat';
import { getPreSaleDeliveryRecord, printPreSaleDeliveryRecord, updatePreSaleDeliveryDetailByUuid, confirmPreSaleDeliveryByUuid } from '@/api/modules/preSale-management/preSale-delivery';
import { getDistributionStationList } from '@/api/modules/distributionStation-management/distributionStationList';
import { FILE_SERVER } from '@/api/modules/files';

export default {
    name: 'PreSaleDeliveryDetail',
    data() {
        return {
            showPoptip:true,
            sendDeliveryDate:'',
            showTransferStation:false,
            showLogistics:false,
            stationList: [],
            deliveryWaysList:[],
            show: false,
            innerSpin: false,
            orderUuid: '',
            preSaleDeliveryRecordUuid: '',
            preSaleDeliveryRecord: {},
			 ruleValidate: {
				 deliveryWaysList:[]
			 },
            preSaleDeliveryDetails: [],
            productTable: {
                columns: [
                    {
					    title: '序号',
                        align: 'center',
                        width:'50',
					    render:(h, params) =>{
                            if(params.row.productCode==''||params.row.productCode=='定金收取(%)'){
								 h('span', '');
                            }
                            else{
                                return h('span', params.index+1);
                            }
					    }
                    },
                    { title: '品种编码', key: 'productCode', align: 'center' },
                    { title: '品种名称', key: 'productName', align: 'center' },
                    { title: '单位', key: 'unitName', align: 'center' },
                    {
					    title: '数量',
                        align: 'center',
					    key: 'orderQuantity'
                    },
                    {
					    title: '单价',
                        align: 'center',
					    key: 'preSalePlanPrice'
                    },
                    { title: '金额', key: 'totalMoney', align: 'center' }
                ]
            }
        };
    },
    mounted() {

    },
    methods: {
        updateRow(row){
            this.preSaleDeliveryDetails.forEach(item =>{
                if(row.preSaleDeliveryDetailUuid==item.preSaleDeliveryDetailUuid){
                    item.orderQuantity=row.orderQuantity;
                    item.preSalePlanPrice=row.preSalePlanPrice;
                }
            });
        },
        updatePreSalePlanPrice(){
            let preSalePlanPrice=this.preSaleDeliveryDetails[0].preSalePlanPrice;
            this.preSaleDeliveryDetails.forEach(item =>{
                if(item.productName){
                    item.preSalePlanPrice=preSalePlanPrice;
                }
            });
        },
        saveDetailInfo(){
		  let sendDeliveryDateNew=this.sendDeliveryDate+" 00:00:00";
		  this.preSaleDeliveryRecord.sendProductDate=sendDeliveryDateNew;
		  this.preSaleDeliveryRecord.orderItmeList.forEach(item =>{
			  this.preSaleDeliveryDetails.forEach(e =>{
				  if(item.preSaleDeliveryDetailUuid&&item.preSaleDeliveryDetailUuid==e.preSaleDeliveryDetailUuid){
					  item.orderQuantity = e.orderQuantity;
					  item.preSalePlanPrice = e.preSalePlanPrice;
				  }
			  });
		  });
		  this.innerSpin = true;
		  updatePreSaleDeliveryDetailByUuid({ preSaleDeliveryRecordVO:this.preSaleDeliveryRecord }).then(res => {
			  this.innerSpin = false;
			  if (res.code === 0) {
				  this.innerSpin = true;
				  getPreSaleDeliveryRecord({ preSaleDeliveryRecordUuid:this.preSaleDeliveryRecordUuid, isSign:2 }).then(res => {
					  this.innerSpin = false;
					  if (res.code === 0) {
						  this.preSaleDeliveryRecord = res.data.recordList[0];
						  this.preSaleDeliveryDetails = res.data.recordList[0].orderItmeList;
						  this.$parent.getMainTableRecords();
						  this.$Message.success('修改的信息保存成功！');
						  
					  }
				  }).catch(() => {
					  this.innerSpin = false;
				  });

			  }
		  });
        },
        onDeliveryWaysChange(val){
            this.showTransferStation = false;
            this.showLogistics = false;
            if(val==1||val==0){
                this.showTransferStation = true;
            }
            else if(val==2){
                this.showLogistics = true;
            }
        },
        ok() {
            // console.log("this.preSaleDeliveryRecord.deliveryWays="+this.preSaleDeliveryRecord.deliveryWays);
            if(this.preSaleDeliveryRecord.deliveryWays==1||this.preSaleDeliveryRecord.deliveryWays==0){
                if(this.preSaleDeliveryRecord.relateDistributionStationUuid==null||this.preSaleDeliveryRecord.relateDistributionStationUuid==''||this.preSaleDeliveryRecord.relateDistributionStationUuid==undefined){
                    console.log("this.preSaleDeliveryRecord.deliveryWaysAAA="+this.preSaleDeliveryRecord.deliveryWays);
                    this.$Message.info('请选择转运站,转运站不能为空！');
                    return;
                }
            }
            // console.log("this.preSaleDeliveryRecord.deliveryWaysBBB="+this.preSaleDeliveryRecord.deliveryWays);
            if(this.preSaleDeliveryRecord.deliveryWays==2){
                if(this.preSaleDeliveryRecord.logisticsCode==null||this.preSaleDeliveryRecord.logisticsCode==''||this.preSaleDeliveryRecord.logisticsCode==undefined){
                    this.$Message.info('发货方式为物流，请填写物流单号');
                    return;
                }
                if(this.preSaleDeliveryRecord.preSaleDeliveryRecordLogisticsCompanyName==null||this.preSaleDeliveryRecord.preSaleDeliveryRecordLogisticsCompanyName==''||this.preSaleDeliveryRecord.preSaleDeliveryRecordLogisticsCompanyName==undefined){
                    this.$Message.info('发货方式为物流，请填写物流公司');
                    return;
                }
            }
            this.innerSpin = true;
            confirmPreSaleDeliveryByUuid({ preSaleDeliveryRecordUuid:this.orderUuid,
                deliveryWays:this.preSaleDeliveryRecord.deliveryWays, shippingNo:this.preSaleDeliveryRecord.logisticsCode,
                shippingCompany:this.preSaleDeliveryRecord.preSaleDeliveryRecordLogisticsCompanyName,
                stationUuid:this.preSaleDeliveryRecord.relateDistributionStationUuid,
                currentDeliveryFee:this.preSaleDeliveryRecord.currentDeliveryFee }).then(res => {
				  if (res.code === 0) {
					  this.showPoptip=false;
					  this.$parent.getMainTableRecords();
					  this.innerSpin = false;
					  this.$Message.success('确认发货成功！');
					  this.show = false;
				  }
				  else if(res.code === 11){
					  this.innerSpin = false;
					  this.$Message.info(res.message);
				  }
            });
        },
        cancel() {
		    this.$Message.info('请再次确认信息');
        },
        onShowChange(e) {
            if (e) {
                this.init();
            }
        },
        showModal(orderUuid) {
            this.orderUuid = orderUuid;
            this.show = true;
        },
        init() {
            this.deliveryWaysList = [];
            this.deliveryWaysList.push({ val: DELIVERYWAYS_SELFMENTION, label: deliveryWaysFormat(DELIVERYWAYS_SELFMENTION) });
            this.deliveryWaysList.push({ val: DELIVERYWAYS_TRANSFERSTATION, label: deliveryWaysFormat(DELIVERYWAYS_TRANSFERSTATION) });
            this.deliveryWaysList.push({ val: DELIVERYWAYS_LOGISTICS, label: deliveryWaysFormat(DELIVERYWAYS_LOGISTICS) });
            getDistributionStationList({}).then(res => {
			    if (res.code === 0) {
                    if(res.data.stationList.length>0){
                        this.stationList = res.data.stationList;
                    }
			    }
            });
            if (this.orderUuid) {
                this.preSaleDeliveryRecordUuid = this.orderUuid;

                this.innerSpin = true;
                getPreSaleDeliveryRecord({ preSaleDeliveryRecordUuid:this.preSaleDeliveryRecordUuid, isSign:2 }).then(res => {
                    this.innerSpin = false;
                    if (res.code === 0) {
                        if(res.data.recordList.length>0){
                            this.showPoptip=res.data.recordList[0].isShowDeliveryBtn;
                            this.onDeliveryWaysChange(res.data.recordList[0].deliveryWays);
                            this.sendDeliveryDate=formatDateString(res.data.recordList[0].preSaleDeliveryRecordDeliveryDate);
                            this.preSaleDeliveryRecord = res.data.recordList[0];
                            this.preSaleDeliveryDetails = res.data.recordList[0].orderItmeList;
                        }
                    }
                }).catch(() => {
                    this.innerSpin = false;
                });
            };
        },
        formatDateString,
        formatDateTimeString,
        printDeliveryRecord() {
            this.$showGlobalSpin();
            printPreSaleDeliveryRecord({ preSaleDeliveryRecordUuid:this.preSaleDeliveryRecordUuid }).then(res => {
                this.$hideGlobalSpin();
                if (res.code === 0) {
                    window.open(DOWNLOAD_SERVER + res.data.url, "_blank");
                }
            }).catch(() => {
                this.$hideGlobalSpin();
            });
        }
    }
};
</script>

<style scoped>
	.ivu-radio-group-button.ivu-radio-group-large .ivu-radio-wrapper{height:32px;line-height:32px;font-size:12px;padding:0px 10px;}
	.ivu-table-cell input{text-align: center;}
</style>
